import { render } from "./NFTSlideItem.vue?vue&type=template&id=f1b9db64&ts=true"
import script from "./NFTSlideItem.vue?vue&type=script&lang=ts"
export * from "./NFTSlideItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__